const vkIcon = require('./vk.svg')
const odnoklassnikiIcon = require('./odnoklassniki.svg')
const instagramIcon = require('./instagram.svg')
const twitterIcon = require('./twitter.svg')
const facebookIcon = require('./facebook.svg')
const youtubeIcon = require('./youtube.svg')
const telegramIcon = require('./telegram.svg')
const whatsappIcon = require('./whatsapp.svg')
const rutubeIcon = require('./rutube.svg')

export {
  vkIcon,
  odnoklassnikiIcon,
  instagramIcon,
  twitterIcon,
  facebookIcon,
  youtubeIcon,
  telegramIcon,
  whatsappIcon,
  rutubeIcon,
}
